(function () {
  'use strict';

  if (window.__waPdpGalleryViewerV2) return;
  window.__waPdpGalleryViewerV2 = true;

  var ROOT_SELECTOR = '[data-woodarq-pdp-hero]';
  var NATIVE_TRIGGER_SELECTOR = '[data-zoom-src]';
  var PRODUCTWIZ_TRIGGER_SELECTOR = '.rio-media-gallery .pwzrswiper-slide, .rio-media-gallery [class*="swiper-slide"]';
  var TRIGGER_SELECTOR = NATIVE_TRIGGER_SELECTOR + ', ' + PRODUCTWIZ_TRIGGER_SELECTOR;
  var CLOSE_DURATION = 280;
  var viewer = null;
  var refs = {};
  var items = [];
  var activeIndex = 0;
  var activeLayer = 0;
  var imageLoadToken = 0;
  var closeTimer = null;
  var activeRoot = null;
  var lastTrigger = null;
  var pointerOrigin = null;
  var swipeOrigin = null;
  var suppressClickUntil = 0;

  function closest(element, selector) {
    return element && element.closest ? element.closest(selector) : null;
  }

  function normaliseIndex(index, length) {
    if (!length) return 0;
    return ((Number(index) || 0) % length + length) % length;
  }

  function isElementVisible(element) {
    if (!element || element.hidden) return false;
    if (element.matches('[data-variant-wizard-hidden="true"], [data-productwiz-hidden="true"], [data-pw-hidden="true"], .variant-wizard-hidden, .productwiz-hidden, .pw-hidden')) return false;

    var style = window.getComputedStyle ? window.getComputedStyle(element) : null;
    return !style || (style.display !== 'none' && style.visibility !== 'hidden');
  }

  function largestSrc(image) {
    if (!image) return '';

    var source = image.getAttribute('data-zoom-src') ||
      image.getAttribute('data-zoom-image') ||
      image.getAttribute('data-large-image') ||
      image.currentSrc ||
      image.src ||
      '';

    if (!image.srcset) return source;

    var candidates = image.srcset.split(',').map(function (candidate) {
      var parts = candidate.trim().split(/\s+/);
      return { src: parts[0] || '', width: parseInt(parts[1], 10) || 0 };
    }).filter(function (candidate) {
      return candidate.src;
    }).sort(function (first, second) {
      return second.width - first.width;
    });

    return candidates.length ? candidates[0].src : source;
  }

  function normaliseSource(source) {
    return String(source || '')
      .replace(/^https?:/, '')
      .replace(/([?&])width=\d+/g, '$1')
      .replace(/[?&]$/, '')
      .split('?')[0];
  }

  function uniqueItems(candidateItems) {
    var seen = Object.create(null);

    return candidateItems.filter(function (item) {
      if (!item || !item.src) return false;
      var key = item.mediaId ? 'media-' + item.mediaId : normaliseSource(item.src);
      if (!key || seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function productTitle(root) {
    var heading = root && root.querySelector('h1, [data-product-title], .wd-pdp__title');
    return heading ? String(heading.textContent || '').replace(/\s+/g, ' ').trim() : 'Product image';
  }

  function readNativeItems(root) {
    if (!root) return [];

    return uniqueItems(Array.prototype.slice.call(root.querySelectorAll('[data-slide-index]')).filter(function (slide) {
      return isElementVisible(slide);
    }).map(function (slide) {
      var opener = slide.querySelector(NATIVE_TRIGGER_SELECTOR);
      var image = opener && opener.querySelector('img');
      var mediaId = slide.getAttribute('data-wd-media-id') || opener && opener.getAttribute('data-media-id') || '';

      return {
        src: opener && opener.getAttribute('data-zoom-src') || largestSrc(image),
        alt: image && image.alt || productTitle(root),
        mediaId: String(mediaId || ''),
        slideIndex: Number(slide.getAttribute('data-slide-index') || 0),
        sourceElement: slide
      };
    }));
  }

  function readProductWizItems(root) {
    if (!root) return [];

    var gallery = root.querySelector('.rio-media-gallery');
    if (!gallery) return [];

    var slides = Array.prototype.slice.call(gallery.querySelectorAll('.pwzrswiper-slide, [class*="swiper-slide"]')).filter(function (slide) {
      return isElementVisible(slide) && Boolean(slide.querySelector('img'));
    });

    return uniqueItems(slides.map(function (slide, index) {
      var image = slide.querySelector('img');
      var mediaId = slide.getAttribute('data-media-id') || image.getAttribute('data-media-id') || '';

      return {
        src: slide.getAttribute('data-zoom-src') || largestSrc(image),
        alt: image.alt || productTitle(root),
        mediaId: String(mediaId || ''),
        slideIndex: index,
        sourceElement: slide
      };
    }));
  }

  function collectItems(root, trigger) {
    var clickedProductWiz = Boolean(closest(trigger, '.rio-media-gallery'));
    var productWizItems = readProductWizItems(root);
    var nativeItems = readNativeItems(root);

    if (clickedProductWiz && productWizItems.length) return productWizItems;
    return nativeItems.length ? nativeItems : productWizItems;
  }

  function clickedItemIndex(trigger, galleryItems) {
    var slide = closest(trigger, '[data-slide-index], .pwzrswiper-slide, [class*="swiper-slide"]');
    var image = trigger.matches && trigger.matches('img') ? trigger : trigger.querySelector && trigger.querySelector('img');
    var source = normaliseSource(
      trigger.getAttribute && trigger.getAttribute('data-zoom-src') || largestSrc(image)
    );
    var mediaId = slide && (slide.getAttribute('data-wd-media-id') || slide.getAttribute('data-media-id')) ||
      trigger.getAttribute && trigger.getAttribute('data-media-id') || '';

    var index = galleryItems.findIndex(function (item) {
      if (mediaId && item.mediaId && String(item.mediaId).endsWith(String(mediaId).replace(/^.*-/, ''))) return true;
      return source && normaliseSource(item.src) === source;
    });

    if (index >= 0) return index;

    index = galleryItems.findIndex(function (item) {
      return item.sourceElement === slide;
    });

    return index >= 0 ? index : 0;
  }

  function buildViewer() {
    if (viewer && document.documentElement.contains(viewer)) return;

    viewer = document.createElement('div');
    viewer.className = 'wa-pdp-gallery-viewer';
    viewer.hidden = true;
    viewer.setAttribute('aria-hidden', 'true');
    viewer.innerHTML = [
      '<button class="wa-pdp-gallery-viewer__backdrop" type="button" data-wa-pdp-gallery-close tabindex="-1" aria-label="Close image viewer"></button>',
      '<div class="wa-pdp-gallery-viewer__dialog" role="dialog" aria-modal="true" aria-label="Product image viewer" data-wa-pdp-gallery-dialog>',
      '  <div class="wa-pdp-gallery-viewer__stage" data-wa-pdp-gallery-stage>',
      '    <img class="wa-pdp-gallery-viewer__image" data-wa-pdp-gallery-image="0" alt="" draggable="false">',
      '    <img class="wa-pdp-gallery-viewer__image" data-wa-pdp-gallery-image="1" alt="" draggable="false">',
      '  </div>',
      '  <div class="wa-pdp-gallery-viewer__controls">',
      '    <button class="wa-pdp-gallery-viewer__control" type="button" data-wa-pdp-gallery-previous aria-label="Previous product image">',
      '      <svg viewBox="0 0 20 20" aria-hidden="true"><path d="m12.5 5-5 5 5 5"/></svg>',
      '    </button>',
      '    <button class="wa-pdp-gallery-viewer__control" type="button" data-wa-pdp-gallery-close aria-label="Close image viewer">',
      '      <svg viewBox="0 0 20 20" aria-hidden="true"><path d="m5.5 5.5 9 9m0-9-9 9"/></svg>',
      '    </button>',
      '    <button class="wa-pdp-gallery-viewer__control" type="button" data-wa-pdp-gallery-next aria-label="Next product image">',
      '      <svg viewBox="0 0 20 20" aria-hidden="true"><path d="m7.5 5 5 5-5 5"/></svg>',
      '    </button>',
      '  </div>',
      '  <span class="wa-pdp-gallery-viewer__counter" data-wa-pdp-gallery-counter></span>',
      '  <span class="wa-pdp-gallery-viewer__status" data-wa-pdp-gallery-status aria-live="polite"></span>',
      '</div>'
    ].join('');

    document.body.appendChild(viewer);

    refs.dialog = viewer.querySelector('[data-wa-pdp-gallery-dialog]');
    refs.stage = viewer.querySelector('[data-wa-pdp-gallery-stage]');
    refs.images = Array.prototype.slice.call(viewer.querySelectorAll('[data-wa-pdp-gallery-image]'));
    refs.previous = viewer.querySelector('[data-wa-pdp-gallery-previous]');
    refs.next = viewer.querySelector('[data-wa-pdp-gallery-next]');
    refs.close = viewer.querySelector('.wa-pdp-gallery-viewer__controls [data-wa-pdp-gallery-close]');
    refs.counter = viewer.querySelector('[data-wa-pdp-gallery-counter]');
    refs.status = viewer.querySelector('[data-wa-pdp-gallery-status]');

    viewer.addEventListener('click', function (event) {
      if (closest(event.target, '[data-wa-pdp-gallery-close]')) {
        event.preventDefault();
        closeViewer();
        return;
      }

      if (closest(event.target, '[data-wa-pdp-gallery-previous]')) {
        event.preventDefault();
        showImage(activeIndex - 1);
        return;
      }

      if (closest(event.target, '[data-wa-pdp-gallery-next]')) {
        event.preventDefault();
        showImage(activeIndex + 1);
      }
    });

    refs.stage.addEventListener('pointerdown', beginSwipe);
    refs.stage.addEventListener('pointermove', moveSwipe);
    refs.stage.addEventListener('pointerup', endSwipe);
    refs.stage.addEventListener('pointercancel', cancelSwipe);
  }

  function preloadAdjacent() {
    if (items.length < 2) return;

    [activeIndex - 1, activeIndex + 1].forEach(function (index) {
      var item = items[normaliseIndex(index, items.length)];
      if (!item || !item.src) return;
      var preload = new Image();
      preload.src = item.src;
    });
  }

  function showImage(index, immediate) {
    if (!items.length || !refs.images || !refs.images.length) return;

    activeIndex = normaliseIndex(index, items.length);
    var item = items[activeIndex];
    var nextLayer = immediate ? 0 : (activeLayer === 0 ? 1 : 0);
    var nextImage = refs.images[nextLayer];
    var token = ++imageLoadToken;

    refs.counter.textContent = String(activeIndex + 1).padStart(2, '0') + ' / ' + String(items.length).padStart(2, '0');
    refs.status.textContent = 'Image ' + (activeIndex + 1) + ' of ' + items.length;

    var reveal = function () {
      if (token !== imageLoadToken) return;
      refs.images.forEach(function (image, layerIndex) {
        image.classList.toggle('is-wa-pdp-gallery-image-active', layerIndex === nextLayer);
      });
      activeLayer = nextLayer;
      preloadAdjacent();
    };

    nextImage.alt = item.alt || productTitle(activeRoot);
    if (nextImage.getAttribute('src') !== item.src) nextImage.src = item.src;

    if (nextImage.complete && nextImage.naturalWidth) reveal();
    else {
      nextImage.onload = reveal;
      nextImage.onerror = reveal;
    }
  }

  function lockPage() {
    document.documentElement.classList.add('wa-pdp-gallery-viewer-open');
    if (document.body) document.body.classList.add('wa-pdp-gallery-viewer-open');
  }

  function unlockPage() {
    document.documentElement.classList.remove('wa-pdp-gallery-viewer-open');
    if (document.body) document.body.classList.remove('wa-pdp-gallery-viewer-open');
  }

  function openViewer(trigger, root) {
    var nextItems = collectItems(root, trigger);
    if (!nextItems.length) return;

    buildViewer();
    window.clearTimeout(closeTimer);

    items = nextItems;
    activeRoot = root;
    lastTrigger = trigger;
    viewer.classList.toggle('has-wa-pdp-single-image', items.length === 1);
    viewer.hidden = false;
    viewer.setAttribute('aria-hidden', 'false');
    lockPage();
    showImage(clickedItemIndex(trigger, items), true);

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        viewer.classList.add('is-wa-pdp-gallery-open');
        try { refs.close.focus({ preventScroll: true }); } catch (error) { refs.close.focus(); }
      });
    });
  }

  function syncUnderlyingGallery() {
    if (!activeRoot || !items.length) return;
    var item = items[activeIndex];

    var mediaGallery = activeRoot.querySelector('media-gallery');
    if (mediaGallery && item.mediaId && typeof mediaGallery.setActiveMedia === 'function') {
      var nativeSlide = Array.prototype.slice.call(activeRoot.querySelectorAll('[data-wd-media-id]')).find(function (slide) {
        return String(slide.getAttribute('data-wd-media-id') || '') === String(item.mediaId);
      });
      var mediaTarget = nativeSlide && nativeSlide.getAttribute('data-media-id');
      if (mediaTarget) mediaGallery.setActiveMedia(mediaTarget, false);
    }

    var dot = activeRoot.querySelector('[data-dot-index="' + item.slideIndex + '"]');
    if (dot && typeof dot.click === 'function') dot.click();

    Array.prototype.slice.call(activeRoot.querySelectorAll('.pwzrswiper, .pwzrswiper-wrapper, .rio-media-gallery')).forEach(function (element) {
      var swiper = element.swiper || element.parentElement && element.parentElement.swiper;
      if (swiper && typeof swiper.slideTo === 'function') swiper.slideTo(item.slideIndex);
    });
  }

  function closeViewer() {
    if (!viewer || viewer.hidden) return;

    syncUnderlyingGallery();
    viewer.classList.remove('is-wa-pdp-gallery-open');
    viewer.setAttribute('aria-hidden', 'true');
    unlockPage();

    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(function () {
      viewer.hidden = true;
      refs.images.forEach(function (image) {
        image.classList.remove('is-wa-pdp-gallery-image-active');
      });

      if (lastTrigger && document.documentElement.contains(lastTrigger) && typeof lastTrigger.focus === 'function') {
        try { lastTrigger.focus({ preventScroll: true }); } catch (error) { lastTrigger.focus(); }
      }
    }, CLOSE_DURATION);
  }

  function beginSwipe(event) {
    if (items.length < 2 || event.pointerType === 'mouse' && event.button !== 0) return;
    swipeOrigin = { id: event.pointerId, x: event.clientX, y: event.clientY, time: Date.now() };

    if (refs.stage.setPointerCapture) {
      try { refs.stage.setPointerCapture(event.pointerId); } catch (error) {}
    }
  }

  function moveSwipe(event) {
    if (!swipeOrigin || swipeOrigin.id !== event.pointerId) return;
    var deltaX = event.clientX - swipeOrigin.x;
    var deltaY = event.clientY - swipeOrigin.y;
    if (Math.abs(deltaX) > 10 && Math.abs(deltaX) > Math.abs(deltaY) * 1.15) event.preventDefault();
  }

  function endSwipe(event) {
    if (!swipeOrigin || swipeOrigin.id !== event.pointerId) return;
    var deltaX = event.clientX - swipeOrigin.x;
    var deltaY = event.clientY - swipeOrigin.y;
    var duration = Date.now() - swipeOrigin.time;
    swipeOrigin = null;

    if (Math.abs(deltaX) >= 48 && Math.abs(deltaX) > Math.abs(deltaY) * 1.15 && duration < 950) {
      showImage(activeIndex + (deltaX < 0 ? 1 : -1));
    }
  }

  function cancelSwipe() {
    swipeOrigin = null;
  }

  function focusableControls() {
    if (!viewer) return [];
    return Array.prototype.slice.call(viewer.querySelectorAll('button:not([disabled]):not([hidden])')).filter(function (control) {
      return control.offsetParent !== null;
    });
  }

  function handleKeydown(event) {
    if (!viewer || viewer.hidden || !viewer.classList.contains('is-wa-pdp-gallery-open')) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeViewer();
      return;
    }

    if (event.key === 'ArrowLeft' && items.length > 1) {
      event.preventDefault();
      showImage(activeIndex - 1);
      return;
    }

    if (event.key === 'ArrowRight' && items.length > 1) {
      event.preventDefault();
      showImage(activeIndex + 1);
      return;
    }

    if (event.key !== 'Tab') return;

    var controls = focusableControls();
    if (!controls.length) return;
    var current = controls.indexOf(document.activeElement);
    var next = event.shiftKey
      ? (current <= 0 ? controls.length - 1 : current - 1)
      : (current + 1) % controls.length;
    event.preventDefault();
    controls[next].focus();
  }

  function findTrigger(target) {
    var trigger = closest(target, TRIGGER_SELECTOR);
    var root = trigger && closest(trigger, ROOT_SELECTOR);
    if (!trigger || !root) return null;

    if (closest(trigger, '.rio-media-gallery') && !trigger.querySelector('img')) return null;
    return { trigger: trigger, root: root };
  }

  document.addEventListener('pointerdown', function (event) {
    var match = findTrigger(event.target);
    if (!match) return;

    pointerOrigin = {
      id: event.pointerId,
      pointerType: event.pointerType || '',
      x: event.clientX,
      y: event.clientY,
      moved: false,
      trigger: match.trigger,
      root: match.root
    };
  }, true);

  document.addEventListener('pointermove', function (event) {
    if (!pointerOrigin || pointerOrigin.id !== event.pointerId) return;
    if (Math.abs(event.clientX - pointerOrigin.x) > 8 || Math.abs(event.clientY - pointerOrigin.y) > 8) {
      pointerOrigin.moved = true;
    }
  }, true);

  document.addEventListener('pointerup', function (event) {
    if (!pointerOrigin || pointerOrigin.id !== event.pointerId) return;
    var origin = pointerOrigin;
    pointerOrigin = null;

    if (origin.moved) {
      suppressClickUntil = Date.now() + 450;
      return;
    }

    // A fine-pointer click can be swallowed by the gallery's mouse drag/pointer
    // capture handling (especially on hybrid touchscreen laptops). Open from the
    // completed mouse pointer gesture itself, while retaining the normal click
    // path for touch, pen, keyboard activation, and dynamically injected slides.
    if (origin.pointerType === 'mouse' && (typeof event.button !== 'number' || event.button === 0)) {
      suppressClickUntil = Date.now() + 600;
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      openViewer(origin.trigger, origin.root);
    }
  }, true);

  document.addEventListener('pointercancel', function () {
    pointerOrigin = null;
  }, true);

  document.addEventListener('click', function (event) {
    var match = findTrigger(event.target);
    if (!match || Date.now() < suppressClickUntil) return;
    if (typeof event.button === 'number' && event.button !== 0) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    openViewer(match.trigger, match.root);
  }, true);

  document.addEventListener('keydown', handleKeydown, true);
  window.addEventListener('pagehide', closeViewer);
  window.addEventListener('popstate', closeViewer);
  document.addEventListener('shopify:section:unload', function (event) {
    if (activeRoot && event.target && event.target.contains(activeRoot)) closeViewer();
  });
})();
